module.exports = __webpack_public_path__ + "static/media/logo_black.0475f9d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/brand/logo_black.png
// module id = 724
// module chunks = 0